// extracted by mini-css-extract-plugin
export var childrenContainer = "_3o-0";
export var virtualScrollArea = "_3o-1";